// extracted by mini-css-extract-plugin
export var footer = "layout-module--footer--rX0Dt";
export var btt = "layout-module--btt--gFyTq";